// extracted by mini-css-extract-plugin
module.exports = {"reject-reason-container":"styles-module__reject-reason-container___3VET6","card":"styles-module__card___2DtiQ"};